export const GLOBAL_POSTAGE_BATCH_ID =
  "0000000000000000000000000000000000000000000000000000000000000000";

export const FDS_DOMAIN = "fds";
